import { render, staticRenderFns } from "./editLeaderboard.vue?vue&type=template&id=2b318ba0&lang=pug"
import script from "./editLeaderboard.vue?vue&type=script&lang=js"
export * from "./editLeaderboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports